import React from "react";
import moment from "moment";

const PaymentVoucher = ({ reservation, client, vehicle, formatCurrency }) => {
    if (!reservation) return null;

    return (
        <div className="bg-white text-xs text-gray-800 p-4 border border-black max-w-[800px] mx-auto">
            {/* Header */}
            <div className="flex justify-between items-center border-b border-black pb-2 mb-2">
                <div>
                    <h1 className="text-base font-bold uppercase">Bon de Versement</h1>
                    <p className="text-[10px]">Reçu de Paiement Officiel</p>
                </div>
                <div className="text-right">
                    <p className="text-[11px]">PV-{reservation.id}-{moment().format("YYYYMMDD")}</p>
                    <p className="text-[10px]">{moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
            </div>

            {/* Company Info */}
            <div className="grid grid-cols-3 border-b border-black pb-1 mb-2">
                <span></span>

                <span className="text-right">dominosoft</span>
            </div>

            {/* Client & Vehicle */}
            <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="border border-black p-2">
                    <p className="font-semibold mb-1">Informations Client</p>
                    <p>Nom: {client ? `${client.nom} ${client.prenom}` : "N/A"}</p>
                    {client?.telephone && <p>Tél: {client.telephone}</p>}
                    {client?.numero_cin && <p>CIN/Passeport: {client.numero_cin}</p>}
                </div>
                <div className="border border-black p-2">
                    <p className="font-semibold mb-1">Informations Véhicule</p>
                    <p>
                        Véhicule: {vehicle ? `${vehicle.marque} ${vehicle.modele}` : "N/A"}
                    </p>
                    {vehicle?.matricule && <p>Immatriculation: {vehicle.matricule}</p>}
                    <p>N° Chassis: {vehicle?.numero_chassis || "N/A"}</p>
                </div>
            </div>

            {/* Rental Period */}
            <div className="border border-black p-2 mb-2">
                <p className="font-semibold mb-1">Période de Location</p>
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <p>Départ: {moment(reservation.date_depart).format("DD/MM/YYYY HH:mm")}</p>
                        {reservation.lieu_depart && <p>{reservation.lieu_depart}</p>}
                    </div>
                    <div>
                        <p>Retour prévu: {moment(reservation.date_retour_prevue).format("DD/MM/YYYY HH:mm")}</p>
                        {reservation.lieu_retour && <p>{reservation.lieu_retour}</p>}
                    </div>
                </div>
                {reservation.date_retour_effective && (
                    <p className="mt-1">
                        Retour effectif:{" "}
                        {moment(reservation.date_retour_effective).format("DD/MM/YYYY HH:mm")}
                    </p>
                )}
            </div>

            {/* Payment Details */}
            <div className="border border-black p-2 mb-2">
                <p className="font-semibold mb-1">Détails de Paiement</p>
                <div>
                    <p>Prix de jour: {formatCurrency(reservation.prix_base)}</p>
                    {reservation.versement > 0 && (
                        <p>versement: -{formatCurrency(reservation.versement)}</p>
                    )}
                    {reservation.remise > 0 && (
                        <p>Remise: -{formatCurrency(reservation.remise)}</p>
                    )}
                    {reservation.retard_prix > 0 && (
                        <p>Pénalité retard: +{formatCurrency(reservation.retard_prix)}</p>
                    )}
                    <p className="font-bold mt-1">
                        Montant Total: {formatCurrency(reservation.total)}
                    </p>
                </div>
            </div>

            {/* Payment Method & Caution */}
            <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="border border-black p-2">
                    <p className="font-semibold mb-1">Mode de Paiement</p>
                    <p>{reservation.mode_paiement.replace("_", " ")}</p>
                </div>
                {reservation.montant_daman > 0 && (
                    <div className="border border-black p-2">
                        <p className="font-semibold mb-1">Caution</p>
                        <p>{formatCurrency(reservation.montant_daman)}</p>
                        <p>{reservation.daman_rendu ? "Restituée" : "En attente"}</p>
                    </div>
                )}
            </div>

            {/* Terms */}
            <div className="border border-black p-2 mb-2">
                <p className="font-semibold mb-1">Conditions Générales</p>
                <p>• Reçu de paiement officiel.</p>
                <p>• Réclamations dans les 48h.</p>
                <p>• Caution restituée après vérification.</p>
                <p>• Conserver ce reçu.</p>
            </div>

            {/* Signatures */}
            <div className="grid grid-cols-2 gap-2 mt-4">
                <div className="text-center">
                    <p className="font-semibold">Signature Client</p>
                    <div className="h-12 border-b border-black mt-6"></div>
                </div>
                <div className="text-center">
                    <p className="font-semibold">Signature Responsable</p>
                    <div className="h-12 border-b border-black mt-6"></div>
                </div>
            </div>

            {/* Footer */}
            <div className="text-center text-[10px] mt-4">
                <p>Document généré électroniquement - Valable sans signature</p>
                <p>
                    Réservation #{reservation.id} | {moment().format("DD/MM/YYYY HH:mm")}
                </p>
            </div>
        </div>
    );
};

export default PaymentVoucher;
